import { Factory } from '../Factory';
import { ResourceWrapperService } from '../utilities/ResourceWrapperService';
import { IConfigService } from '../config';

export class ReviewMetricsService implements IService {
  protected resourceWrapperService: ResourceWrapperService;
  private configService: IConfigService;
  private $rootScope: IRootScope;

  private numReviewedNotReviewedMetricsForBatch;
  private numReviewedMetricsForProject;
  private numNotReviewedMetricsForProject;

  constructor($rootScope: IRootScope, $resource: angular.resource.IResourceService, configService: IConfigService, resourceWrapperService: ResourceWrapperService) {
    this.$rootScope = $rootScope;
    this.configService = configService;
    this.resourceWrapperService = resourceWrapperService;

    let baseUrl = configService.getServerBaseUrlForResource();

    this.numReviewedNotReviewedMetricsForBatch = this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/reviewmetrics/batch/:batchId`,
      {id: "@id", batchId: "@batchId"},
      {query: {method: "GET", isArray: false}}
    ));

    this.numReviewedMetricsForProject = this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/reviewmetrics/batch/reviewed`,
      {id: "@id"}
    ));

    this.numNotReviewedMetricsForProject = this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/reviewmetrics/batch/notreviewed`,
      {id: "@id"}
    ));

  }

  public async BroadcastNumReviewedNotReviewed(projectId: string, batchId: string) {
    if (projectId && batchId) {
      const data = await this.GetNumReviewedNotReviewedForBatch(projectId, batchId);
      this.$rootScope.$broadcast("reviewmetrics.batch.reviewed", {batchId: batchId, count: data["reviewed"]});
      this.$rootScope.$broadcast("reviewmetrics.batch.notReviewed", {batchId: batchId, count: data["notReviewed"]});
    }
  }

  public async GetNumReviewedNotReviewedForBatch(projectId: string, batchId: string) {
    if (projectId && batchId) {
      return this.numReviewedNotReviewedMetricsForBatch.query({
        id: projectId,
        batchId: batchId
      }).$promise;
    }
  }

  public async GetNumReviewedForProject(projectId: string) {
    if (projectId) {
      return this.numReviewedMetricsForProject.query({
        id: projectId
      }).$promise;
    }
  }

  public async GetNumNotReviewedForProject(projectId: string) {
    if (projectId) {
      return this.numNotReviewedMetricsForProject.query({
        id: projectId
      }).$promise;
    }
  }

}

frontendApp.factory("ReviewMetricsService", ["$rootScope", "$resource", "ConfigService", "ResourceWrapperService", Factory.Create(ReviewMetricsService)]);
